module.exports = __webpack_public_path__ + "img/swiper_3.5_3_1.9e6ba780.webp";